import { Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import {MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig, MatLegacySnackBarRef as MatSnackBarRef, LegacySimpleSnackBar as SimpleSnackBar} from '@angular/material/legacy-snack-bar';

export class SnackBarMessage  {
  message: string;
  action: string = null;
  config: MatSnackBarConfig = null;
}

@Injectable()
export class SnackBarService implements OnDestroy {
  private snackBarRef:  MatSnackBarRef<SimpleSnackBar>;
  private msgQueue = [];
  private isInstanceVisible = false;
  private subscription: Subscription;

  constructor(public snackBar: MatSnackBar) {
  }

  showNext() {
    if (this.msgQueue.length === 0) {
      return;
    }

    const message = this.msgQueue.shift();
    this.isInstanceVisible = true;
    this.snackBarRef = this.snackBar.open(message.message, message.action, message.config);
    this.snackBarRef.afterDismissed().subscribe(() => {
      this.isInstanceVisible = false;
      this.showNext();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Add a message
   * @param message The message to show in the snackbar.
   * @param action The label for the snackbar action.
   * @param config Additional configuration options for the snackbar.
   */
  add(message: string, action?: string, config?: MatSnackBarConfig): void {

    const sbMessage = new SnackBarMessage();
    sbMessage.message = message;
    sbMessage.action = action;
    sbMessage.config = config;

    this.msgQueue.push(sbMessage);
    if (!this.isInstanceVisible) {
      this.showNext();
    }
  }
}
